interface QuestionBubbleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const QuestionBubbleSVG = ({ color, style }: QuestionBubbleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 41.25C25.7335 41.25 28.8507 40.4287 31.6115 38.8908L39.5525 39.5525L38.8908 31.6115C40.4287 28.8507 41.25 25.7335 41.25 22.5C41.25 12.1447 32.8553 3.75 22.5 3.75C12.1447 3.75 3.75 12.1447 3.75 22.5C3.75 32.8553 12.1447 41.25 22.5 41.25ZM30.2156 35.3665L30.7343 35.0547L35.4475 35.4475L35.0547 30.7343L35.3665 30.2156C36.7557 27.9045 37.5 25.2591 37.5 22.5C37.5 14.2157 30.7843 7.5 22.5 7.5C14.2157 7.5 7.5 14.2157 7.5 22.5C7.5 30.7843 14.2157 37.5 22.5 37.5C25.2591 37.5 27.9045 36.7557 30.2156 35.3665ZM22.5006 31.8719C23.5365 31.8719 24.3762 31.0324 24.3762 29.9969C24.3762 28.9614 23.5365 28.1219 22.5006 28.1219C21.4647 28.1219 20.625 28.9614 20.625 29.9969C20.625 31.0324 21.4647 31.8719 22.5006 31.8719ZM20.625 26.25H24.375V24.375C24.375 24.3796 24.3839 24.3698 24.4039 24.3477C24.4531 24.2935 24.5697 24.165 24.7884 23.9915C24.9762 23.8425 25.0345 23.8039 25.509 23.5031C27.1238 22.4794 28.125 20.6992 28.125 18.75C28.125 15.6434 25.6066 13.125 22.5 13.125C19.3934 13.125 16.875 15.6434 16.875 18.75H20.625C20.625 17.7145 21.4645 16.875 22.5 16.875C23.5355 16.875 24.375 17.7145 24.375 18.75C24.375 19.4012 24.0423 19.9929 23.5012 20.3359C22.8941 20.7208 22.7933 20.7876 22.4578 21.0537C21.3426 21.9384 20.625 22.9925 20.625 24.375V26.25Z"
      fill={color}
    />
  </svg>
);

export default QuestionBubbleSVG;
